let $ = window.jQuery;

function onDocumentReady(){
    $('.modal-button').on('click', onClickModalButton);
    $('.webcam-image').on('click', 'img', onClickWebcamImage);
}

function onClickWebcamImage(e){
    let clicked = $(e.currentTarget);

    $.magnificPopup.open({
        type: 'image',
        items: { src: clicked.attr('src') }
    });
}

function onClickModalButton(e){
    let clicked = $(e.currentTarget);

    $.magnificPopup.open({
        type: 'inline',
        items: { src: '#' + clicked.attr('data-modal') }
    });
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
